<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
<!--    <Title :title="title"></Title>-->
    <Setp :nodes="nodes" :audits="audits"></Setp>
    <el-card class="box-card" style="min-height: 650px; margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>
        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>
        <slot></slot>
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit == true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input
              type="textarea"
              rows="5"
              maxlength="500"
              show-word-limit
              v-model="ruleForm.auditOpinion"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "@/components/Title";
import Setp from "@/components/item/common/Setp";
import AuditList from "@/components/item/common/AuditList";
import { requestAudit, requestAuditShow } from "@/api";

export default {
  name: "Detail",
  components: { Title, Setp, AuditList },
  props: ['detailQuery','title','nodes','audits','auditHistory','user'],
  data() {
    return {
      allowAudit: false,
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      }
    }
  },
  created() {
    this.applyId = this.detailQuery.applyId
    this.applyServiceId = this.detailQuery.applyServiceId
    this.applyType = this.detailQuery.applyType
    this.title.path = this.detailQuery.fullPath
    this.getAuditShow()
  },
  methods: {
    async getAuditShow() {
      const res = await requestAuditShow({applyId: this.applyId,})
      if (res.code == 200) {
        this.allowAudit = res.object == 1
      }
    },
    async audit(isAgree) {
      this.allowAudit = false
      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      const res = await requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      })
      if (res.code == 200) {
        this.getAuditShow()
        this.$message.success(res.msg)
        this.$emit('complete')
      } else {
        this.$message.error(res.msg)
      }
    }
  }
};
</script>
